import React from 'react';

const GrowthComponent = () => {
  const growthImage="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Growth.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image side */}
          <div className="w-full md:w-2/5">
            <img 
              src={growthImage} 
              alt="Liquidity Portfolio" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">G: Growth – Long-Term Compounding Through Equities</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">This is where wealth is truly built</h3>
            
            <p className="text-gray-700 mb-4">
              In this bucket, we apply Maxiom Wealth's proprietary Roots & Wings philosophy:
            </p>
            
            <h4 className="font-medium text-[#113262] mb-2">Roots:</h4>
            <ul className="mb-4 space-y-2">
              {["Strong balance sheets", "Low debt", "High return on equity", "Trustworthy management"].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <h4 className="font-medium text-[#113262] mb-2">Wings:</h4>
            <ul className="mb-4 space-y-2">
              {["Consistent profit growth", "Revenue momentum", "Market leadership"].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              Your equity portfolio is carefully constructed to maximise compounding while managing risk. No fads. No market noise. Just high-conviction ideas backed by research.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrowthComponent;